import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { routerMiddleware } from 'react-router-redux';
import { connectRouter } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';
import {
  persistStore,
  persistCombineReducers,
  createTransform,
} from 'redux-persist';
import reducers from './reducers';
import sagas from './sagas/index';
import localforage from 'localforage';

export const history = createBrowserHistory();

const featureToggleTransform = createTransform(
  (inboundState) => {
    return {
      ...inboundState,
      features: Array.from(inboundState.features),
    };
  },
  (outboundState) => {
    return {
      ...outboundState,
      features: new Map(outboundState.features),
    };
  },
  { whitelist: ['featureToggle'] }
);

const persistConfig = {
  key: 'root',
  storage: localforage,
  transforms: [featureToggleTransform],
  blacklist: ['availability'],
};

const rootReducer = persistCombineReducers(persistConfig, {
  ...reducers,
  router: connectRouter(history),
});

const routingMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

// Redux Dev tools
const composeEnhancers = composeWithDevTools({
  serialize: {
    options: {
      map: true,
    },
  },
});

export const configureStore = (
  preloadedState,
  options = {
    shouldPersist: true,
  }
) => {
  const enhancers = [applyMiddleware(sagaMiddleware, routingMiddleware)];

  // Create store
  const store = createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(...enhancers)
  );

  // Persist store
  const persistor = options.shouldPersist ? persistStore(store) : null;

  // Run sagas
  sagaMiddleware.run(sagas);

  return { persistor, store };
};

export const { store, persistor } = configureStore();
